import React from "react";

interface AnnouncementProps {
    startDate: Date;
    endDate: Date;
}
export const Announcement: React.FC<
    React.PropsWithChildren<AnnouncementProps>
> = (props) => {
    const { startDate, endDate } = props;

    const today = new Date();
    const visible = startDate <= today && today <= endDate;
    return (
        <div
            style={{
                backgroundColor: "#4f0c0c",
                padding: "24px",
                color: "white",
                display: visible ? "flex" : "none",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            {props.children}
        </div>
    );
};
